import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ServiceCards from './components/ServiceCards';
import FeaturedCases from './components/FeaturedCases';
import StatsBanner from './components/StatsBanner';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  const { t } = useTranslation();

  const homepageSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '果冻传媒',
        url: 'https://www.guodongmedia.com',
        description: '果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-9999',
          contactType: 'customer service',
          areaServed: 'CN',
          availableLanguage: 'Chinese',
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressRegion: '朝阳区',
          streetAddress: '建国路88号SOHO现代城A座',
        },
      },
      {
        '@type': 'WebSite',
        name: '果冻传媒',
        url: 'https://www.guodongmedia.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.guodongmedia.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '果冻传媒 - 首页',
        description: '果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务。',
        url: 'https://www.guodongmedia.com',
        isPartOf: { '@type': 'WebSite', name: '果冻传媒' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '果冻传媒提供哪些服务？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '果冻传媒提供短视频制作、品牌营销、广告策划、社交媒体运营、内容创意、全案整合营销等服务。',
            },
          },
          {
            '@type': 'Question',
            name: '果冻传媒的短视频制作周期是多久？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '单条短视频制作周期通常为3-7个工作日，系列化或大型项目需更长时间，具体视项目复杂度而定。',
            },
          },
          {
            '@type': 'Question',
            name: '果冻传媒服务过哪些行业？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '服务覆盖科技、消费品、美妆、食品饮料、教育、汽车、金融等多个行业。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="果冻传媒 - 创意内容营销与品牌传播平台"
        description="果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务。果冻传媒凭借顶尖创意团队与丰富行业经验，助力品牌实现高效曝光与用户增长。"
        keywords="果冻传媒,果冻传媒短视频制作,果冻传媒品牌营销,果冻传媒广告策划,果冻传媒社交媒体运营,果冻传媒内容创意,果冻传媒全案服务"
        canonicalUrl="https://www.guodongmedia.com"
        ogImage="https://readdy.ai/api/search-image?query=Guodong%20Media%20creative%20content%20marketing%20agency%20brand%20communication%20platform%2C%20warm%20coral%20and%20gold%20modern%20design%2C%20professional%20clean%20aesthetic&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={homepageSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceCards />
        <FeaturedCases />
        <StatsBanner />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}